import {FC} from "react";
import {TeamSpace} from "@jane/lib/src/api/repositories/documentation-library-repository";
import {useDocumentationLibraryContext} from "@jane/lib/src/components/tiptap/context/DocumentationLibraryContext";
import {useTeamData} from "../../../resources/TeamContext";
import {useModal} from "@jane/lib/src/components/layout/ModalProvider";
import {AddFolderModal} from "../../../modals/documentation/AddFolderModal";
import {AddPageModal} from "../../../modals/documentation/AddPageModal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faPeopleGroup, faPlus} from "@fortawesome/free-solid-svg-icons";
import {faCog} from "@fortawesome/pro-solid-svg-icons";
import {Link} from "react-router-dom";
import {TeamSpacePageRow} from "./TeamSpacePageRow";
import {TeamSpaceFolderRow} from "./TeamSpaceFolderRow";
import {AddPortal} from "../portals/AddPortal";

export const TeamSpaceRow: FC<{ space: TeamSpace }> = (props) => {
  const { getPages, pages, templates, onSpacesUpdated, selectedSpace, setSelectedSpace, canEdit, canManage } = useDocumentationLibraryContext();
  const { teams } = useTeamData();
  const addPageModal = useModal({title: "Pagina toevoegen", body: <AddPageModal teamSpaceId={props.space.id} templates={templates} onFinished={() => { onSpacesUpdated();getPages(props.space.id) }}/>, size: "md"});
  const addFolderModal = useModal({title: "Map toevoegen", body: <AddFolderModal teamSpaceId={props.space.id} onFinished={() => { onSpacesUpdated();getPages(props.space.id) }} />, size: 'md'})

  return <div className={"my-0.5"}>
      <div className={"flex flex-row py-2 px-2 space-x-4 items-center hover:bg-brand-50 hover:cursor-pointer rounded-sm"} onClick={() => {
          setSelectedSpace(props.space.id);
          getPages(props.space.id);
        }}>
        <div className={"flex items-center justify-center h-10 w-10 min-h-10 min-w-10 rounded-sm overflow-hidden bg-brand-50 text-brand-primary border border-brand-primary shadow-md"}>
          {props.space.image ? <img src={props.space.image} alt={"space-image"} />
           : <FontAwesomeIcon icon={faPeopleGroup} />}
        </div>

        <div className={"flex-1 min-w-0"}>
          <div className={"flex flex-col"}>
            <div className={"text-sm truncate"}>{props.space.name}</div>

            <div className={"text-xs text-gray-500 truncate"}>
              {teams.find((t) => t.id === props.space.ons_team_id)?.name ?? props.space.ons_team_id}
            </div>
          </div>
        </div>

        {selectedSpace === props.space.id && canManage(props.space) && (
          <Link className={"px-1 py-0.5 rounded-full hover:bg-brand-100 shrink-0"} to={`/samen-werken/${props.space.id}/instellingen`}>
            <FontAwesomeIcon icon={faCog} className={"text-sm opacity-75"} />
          </Link>
        )}
        <FontAwesomeIcon
          icon={faChevronDown}
          className={`shrink-0 transition-transform duration-300 ${selectedSpace !== props.space.id ? "-rotate-90" : "rotate-0"}`}
        />
      </div>

      {selectedSpace && <div className={`overflow-hidden transition-all duration-300 ease-in-out ${selectedSpace !== props.space.id ? "max-h-0 opacity-0 -translate-y-2" : "opacity-100 translate-y-0"}`}>
          {canEdit(props.space) &&
            <AddPortal trigger={
              <div className={"ml-4 px-2 py-1 rounded-sm flex flex-row space-x-4 mt-2 items-center text-brand-primary hover:bg-brand-50 hover:cursor-pointer"}>
                <FontAwesomeIcon icon={faPlus} />
                <div>Nieuw</div>
              </div>
            } onAddPage={addPageModal.open} onAddFolder={addFolderModal.open}/>
          }

          {pages && pages.length > 0 &&
            pages.filter((p) => p.teamSpaceId === props.space.id)
              .filter((p) => p.parentItemId === null)
              .map((item, index) => {
                if (item.type === 'page') {
                  return <TeamSpacePageRow space={props.space} item={item} key={index} />;
                } else {
                  return <TeamSpaceFolderRow space={props.space} folder={item} key={index} />
                }
              })}
        </div>
      }
    </div>
};